<template>

    <ul class="contaier">
        <!-- <li class="header" v-if="isShowHearder">
            <div 
                :class="tickerModel == 1 ? 'header-item theme-color-font':'header-item'"
            >
                <span v-touch:tap="onChangeTab(1)" >个人</span>
            </div>
            <div 
                :class="tickerModel == 2 ? 'header-item theme-color-font':'header-item'"
            >
                <span v-touch:tap="onChangeTab(2)" >团队</span>
            </div>
        </li>
        <li class="header-line" v-if="isShowHearder">
            <div 
                :class="tickerModel == 1 ? 'line':'line line-right'"
            >
                <div class="inner-line theme-color-bg"></div>
            </div>
        </li> -->

        <li class="calendar-box">
            <div id="calendar" class="calendar unified-box-bottom"></div>
        </li>

        <!-- <li class="environment-box unified-box-bottom">
            <div class="environment-left">
                <i class="iconfont iconicon icon-size theme-color-font"></i>
                <span class="tips-txt">参观环境:</span>
            </div>
            <div class="environment-right">
                十分舒适，预约人数较少（仅供参考）
            </div>
        </li> -->

        <!-- style="margin-bottom: 0 !important;"  -->
<!-- 
        <li  class="admission-time" >
            <div class="admission-left" >
                <i class="iconhebei iconshizhong icon-size"></i>
                <span class="tips-txt">入馆时间:</span>
            </div>

            <ul class="admission-right">
                <li 
                    class="right-item"
                    :class="item.status === 1 ? timeActive === item._id ? 'right-item-active theme-box-border theme-color-bg ': '' : 'theme-color-bg prohibit-item gray-color'"
                    v-for="(item, index) in getTimeArray" :key="index"
                    v-touch:tap="onChangeTimeActive(item)"
                >
                    {{item._time}}
                </li>
            </ul>

        </li> -->

        <li class="admission-time f-c">
            <div class="admission-left" style="padding:0;">
                <!-- <i class="iconhebei iconren1 icon-size2 theme-color-font"></i> -->
                <span class="tips-txt">剩余名额:</span>
            </div>
            <div class="admission-right">{{getTimeSlotNumber}}个</div>
            <!-- <div class="admission-right">
                剩余名: {{getTimeSlotNumber}}个
            </div> -->
        </li>

        <li class="tips-box-body" v-if="isShowHearder">
            <ul class="render-box">
                <li class="render-tite f-s-b">
                    <i class="iconhebei icontishi icon-size"></i>
                    <span>温馨提示</span>
                </li>
                <li>
                    <p> 温馨提示：如需取消请提前1天取消，预约后不参加将被纳入馆方黑名单，一年内不可再次预约馆方任何活动 </p>
                </li>
                <!-- <li>1、预约活动前，请提前预约博物院参观门票。</li> -->
                <!-- <li>2、未成年人需在家长的带领下提前20分钟到达展馆进行现场签到。</li> -->
                <!-- <li>3、如需取消请提前1天取消，预约后不参加将被纳入馆方黑名单，一年内不可再次预约馆方任何活动。</li> -->
            </ul>
        </li>

        <!-- <li class="check-box" v-if="isShowHearder">
            <span v-touch:tap="checkChange">
                <i v-if="check" class="theme-color-font iconhebei iconxuanzhong"></i>
                <i v-else class="theme-color-font iconhebei iconweixuanzhong"></i>
                <span class="txt">我已阅读预约须知</span>
            </span>
        </li> -->

        <li class="next-box" >
            <div class="next-box-left">
                <span class="item">已选:</span>
                <span class="item">{{getChooseYear}}</span>
                <!-- <span class="item">{{getChooseTime}}</span> -->
            </div>
            <div 
                v-touch:tap="nextStep"
                class="next-box-right theme-color-bg zx-active-botton"
                :class="check? '':'gray-btn'"
            >
                下一步
            </div>
        </li>

    </ul>

</template>

<script>

    import jQuery from '../../lib/js/jquery.js'
    var $ = jQuery;

    function Calendar(jQuery, window, document){
        var Calendar = function (elem, options) {
            this.$calendar = elem;

            this.defaults = {
                ifSwitch: true,
                hoverDate: false,
                backToday: false,
                callBack:()=>{
                    console.log('切换完成',this.chooseDate)
                }
            };

            this.opts = $.extend({}, this.defaults, options);

        };

        Calendar.prototype = {
            showHoverInfo: function (obj) { // hover 时显示当天信息

            var _dateStr = $(obj).attr('data');
            var offset_t = $(obj).offset().top + (this.$calendar_today.height() - $(obj).height()) / 2;
            var offset_l = $(obj).offset().left + $(obj).width();
            var changeStr = _dateStr.substr(0, 4) + '-' + _dateStr.substr(4, 2) + '-' + _dateStr.substring(6);
            var _week = changingStr(changeStr).getDay();
            var _weekStr = '';

            //  处理只能点击有票的
            var array = this.opts.calendarData,
                flag = true;
            array.map(item=>{
                if(String(item.time) === String(_dateStr)){
                    flag = false;
                }
            })
            if(flag) return;
            $('.active-date').removeClass('active-date')
            obj.addClass('active-date')

            // this.$calendar_today.show();

            this.$calendar_today
                .css({left: offset_l + 30, top: offset_t})
                .stop()
                .animate({left: offset_l + 16, top: offset_t, opacity: 1});

            switch(_week) {
                case 0:
                _weekStr = '星期日';
                break;
                case 1:
                _weekStr = '星期一';
                break;
                case 2:
                _weekStr = '星期二';
                break;
                case 3:
                _weekStr = '星期三';
                break;
                case 4:
                _weekStr = '星期四';
                break;
                case 5:
                _weekStr = '星期五';
                break;
                case 6:
                _weekStr = '星期六';
                break;
            }

            this.$calendarToday_date.text(changeStr);
            this.$calendarToday_week.text(_weekStr);

            this.chooseDate = _dateStr;
            this.opts.callBack();

            },

            showCalendar: function () { // 输入数据并显示

                var self = this;
                var year = dateObj.getDate().getFullYear();
                var month = String(dateObj.getDate().getMonth() + 1);
                var dateStr = returnDateStr(dateObj.getDate());
                var firstDay = new Date(year, month - 1, 1); // 当前月的第一天

                this.$calendarTitle_text.text(year + '年' + dateStr.substr(4, 2) + '月' ) ;

                this.$calendarDate_item.each(function (i) {
                    
                    // allDay: 得到当前列表显示的所有天数
                    var allDay = new Date(year, month - 1, i + 1 - firstDay.getDay());
                    var allDay_str = returnDateStr(allDay);

                    // $(this).text(allDay.getDate()).attr('data', allDay_str);
                    $(this).attr('data', allDay_str);
                    $(this).empty()

                    var array = self.opts.calendarData,
                        tempClosureArray = self.opts.closureData,
                    
                    //  过滤筛选当天展示的票数
                    tempArray = array.filter(function(item){
                        if(item.time === allDay_str) return item;
                    }),

                    //  过滤闭馆时间
                    tempClosureArrayShow = tempClosureArray.filter(function(item){
                        if(item === allDay_str) return item;
                    })

                    var dom = "<div class='rili-inner-box'>" 
                        dom += '<div class="calendar-time" >'+ allDay.getDate() +'</div>' 
                    //  票
                    if(tempArray.length === 1){
                        const item = tempArray[0] 
                        dom += '<div class="calendar-number" >'+ item.number +'</div>' 
                    }

                    //  闭馆
                    if(tempClosureArrayShow.length === 1){
                        dom += '<div class="calendar-closure" >'+ '闭馆' +'</div>' 
                    }

                    dom += '</div>' 

                    $(this).append(dom);


                    //  今天
                    if (returnDateStr(new Date()) === allDay_str) {
                        
                        //  初始选中赋值
                        // self.chooseDate = allDay_str;
                        var tempObj = null;

                        if(array.length >= 1){
                            tempObj = array[0]
                            self.chooseDate = tempObj.time;
                        }
                        //  对今天的选中选中效果
                        // $(this).attr('class', 'item item-curDay active-date');
                        $(this).attr('class', 'item item-curDay');
                    } else if (returnDateStr(firstDay).substr(0, 6) === allDay_str.substr(0, 6)) {
                        $(this).attr('class', 'item item-curMonth');
                    } else {
                        $(this).attr('class', 'item');
                    }

                    // $('.calendar-date .item').click(function(){
                    //   console.log(1)
                    // })


                });
            },

            renderDOM: function () { // 渲染DOM
                this.$calendar_title = $('<div class="calendar-title"></div>');
                this.$calendar_week = $('<ul class="calendar-week"></ul>');
                this.$calendar_date = $('<ul class="calendar-date"></ul>');
                this.$calendar_today = $('<div class="calendar-today"></div>');


                var _titleStr = '<a href="#" class="title"></a>'+
                                '<a href="javascript:;" id="backToday">T</a>'+
                                '<div class="arrow">'+
                                    // '<span class="arrow-prev"><</span>'+
                                    // '<span class="arrow-next">></span>'+
                                    '<span class="arrow-prev"><i class="iconhebei iconfont-prev iconjiantou"></i></span>'+
                                    '<span class="arrow-next"><i class="iconhebei iconfont-next iconjiantou"></i></span>'+
                                '</div>';
                var _weekStr = '<li class="item">日</li>'+
                                '<li class="item">一</li>'+
                                '<li class="item">二</li>'+
                                '<li class="item">三</li>'+
                                '<li class="item">四</li>'+
                                '<li class="item">五</li>'+
                                '<li class="item">六</li>';
                var _dateStr = '';
                var _dayStr = '<i class="triangle"></i>'+
                                '<p class="date"></p>'+
                                '<p class="week"></p>';

                for (var i = 0; i < 6; i++) {
                    _dateStr += '<li class="item">26</li>'+
                                '<li class="item">26</li>'+
                                '<li class="item">26</li>'+
                                '<li class="item">26</li>'+
                                '<li class="item">26</li>'+
                                '<li class="item">26</li>'+
                                '<li class="item">26</li>';
                }
        
                this.$calendar_title.html(_titleStr);
                this.$calendar_week.html(_weekStr);
                this.$calendar_date.html(_dateStr);
                this.$calendar_today.html(_dayStr);

                this.$calendar.append(this.$calendar_title, this.$calendar_week, this.$calendar_date, this.$calendar_today);
                this.$calendar.show();
            },

            inital: function () { // 初始化
            var self = this;

            this.renderDOM();

            this.$calendarTitle_text = this.$calendar_title.find('.title');
            this.$backToday = $('#backToday');
            this.$arrow_prev = this.$calendar_title.find('.arrow-prev');
            this.$arrow_next = this.$calendar_title.find('.arrow-next');
            this.$calendarDate_item = this.$calendar_date.find('.item');
            this.$calendarToday_date = this.$calendar_today.find('.date');
            this.$calendarToday_week = this.$calendar_today.find('.week');

            this.showCalendar();
            
            if (this.opts.ifSwitch) {
                var _this = this;
                this.$arrow_prev.bind('click', function () {
                    var _date = dateObj.getDate();

                    dateObj.setDate(new Date(_date.getFullYear(), _date.getMonth() - 1, 1));

                    self.showCalendar();
                    $(`li[data='${_this.chooseDate}']`).addClass('active-date');
                });

                this.$arrow_next.bind('click', function () {
                
                    var _date = dateObj.getDate();

                    dateObj.setDate(new Date(_date.getFullYear(), _date.getMonth() + 1, 1));

                    self.showCalendar();
                    $(`li[data='${_this.chooseDate}']`).addClass('active-date');
                });
            }

            if (this.opts.backToday) {
                this.$backToday.bind('click', function () {
                
                if (!self.$calendarDate_item.hasClass('item-curDay')) {
                    dateObj.setDate(new Date());

                    self.showCalendar();
                }
                });
            }

            this.$calendarDate_item.hover(function () {
                self.showHoverInfo($(this));
            }, function () {
                self.$calendar_today.css({left: 0, top: 0}).hide();
            });
            },

            constructor: Calendar
        };

        $.fn.calendar = function (options) {
            var calendar = new Calendar(this, options);
            calendar.inital();
            return calendar;
        };

        // ========== 使用到的方法 ==========

        var dateObj = (function () {
            var _date = new Date();

            return {
            getDate: function () {
                return _date;
            },

            setDate: function (date) {
                _date = date;
            }
            }
        })();

        function returnDateStr(date) { // 日期转字符串
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();

            month = month <= 9 ? ('0' + month) : ('' + month);
            day = day <= 9 ? ('0' + day) : ('' + day);

            return year + month + day;
        };

        function changingStr(fDate) { // 字符串转日期
            var fullDate = fDate.split("-");
            
            return new Date(fullDate[0], fullDate[1] - 1, fullDate[2]); 
        };
    }    

    import { 
        getCalendarUrl,
    } from '@ticketUrl';

    import util from '@util';
    export default {
        data() {
            return {
                //  显示完整门票页面
                isShowHearder: true,
                ticketId: '',
                calendarObj:{},//   日历对象
                currendDate:'',//   选择的日期 例如 20191212
                tickerModel: 1,//   1 : 个人 2:团队
                check: false,//  是否阅读须知,
                timeActive: 0,
                timeArray:[
                    // {
                    //     _id:1,
                    //     _time:'09:00 - 12:00',
                    // },
                    // {
                    //     _id:2,
                    //     _time:'13:00 - 17:00',
                    // },
                    // {
                    //     _id:3,
                    //     _time:'14:00 - 18:00',
                    // },
                    // {
                    //     _id:4,
                    //     _time:'15:00 - 19:00',
                    // },
                ],
                calendarData: [
                    // {
                    //     time:'20200225',
                    //     number: 1000,
                    // },
                    // {
                    //     time:'20200226',
                    //     number: 998,
                    // },
                    // {
                    //     time:'20200227',
                    //     number: 886,
                    // },
                    // {
                    //     time:'20200228',
                    //     number: 886,
                    // },
                ],
                closureArray: [],
                type: '',//..下单辨别门票和临展
                defaultStartTime: '',
                defaultEndTime: '',
                activityId: '',
            }
        },


        mounted() {
            this.init();
        },

        methods:{
            getQueryParams(){
                const {
                    activityId = ''
                } = this.$route.query;
                this.activityId = activityId;
                // if(type === 'exhibition'){
                //     this.exhibitionId = eId;
                //     window.document.title = '临展预约';
                //     this.isShowHearder = false;
                // }
                this.getAppointsByActivityId();
                // this.getCalendarData();
            },
            init(){
                this.getQueryParams();
            },
            async getAppointsByActivityId(){
                var data = await this.$api.getAppointsByActivityId(this.activityId);
                // debugger
                // console.log(data)

                const {
                    data: {
                        closeDate: closeArray,
                        times: tempTimeArray,
                        dates: calendarDataArray,
                        startTime: defaultStartTime = '09:00:00',
                        endTime: defaultEndTime = '17:00:00',                            
                    }
                } = data;
                this.defaultStartTime = String(defaultStartTime).substr(0,String(defaultStartTime).lastIndexOf(':'));
                this.defaultEndTime = String(defaultEndTime).substr(0,String(defaultEndTime).lastIndexOf(':'));

                //  入馆时间
                this.timeArray = [];

                //  日历数据
                this.calendarData = [];

                calendarDataArray.map(item=>{
                    this.calendarData.push({
                        time: item.dateTime,
                        number: item.restNum,
                        restNum: item.restNum,
                        id: item.appointSet,
                    })
                }) 

                //  闭馆时间
                this.closureArray = closeArray;

                this.createAlendar();
                //  选中最近的一个入馆时间
                if(this.calendarData.length >= 1){
                    const obj = this.calendarData[0];
                    $(`li[data='${obj.time}']`).addClass('active-date')
                }

            },
            getCalendarData(){
                this.$http.get(
                    getCalendarUrl, { 
                            params: {
                                'ticketId':this.ticketId,
                                'channel': 2,//..H5固定写死
                                'exhibitionId': this.exhibitionId
                            }
                        }
                    ) 
                .then(res=>{
                    const {
                        data: {
                            closeDate: closeArray,
                            times: tempTimeArray,
                            dates: calendarDataArray,
                            startTime: defaultStartTime = '09:00:00',
                            endTime: defaultEndTime = '17:00:00',                            
                        }
                    } = res;
                    this.defaultStartTime = String(defaultStartTime).substr(0,String(defaultStartTime).lastIndexOf(':'));
                    this.defaultEndTime = String(defaultEndTime).substr(0,String(defaultEndTime).lastIndexOf(':'));

                    //  入馆时间
                    this.timeArray = [];
                    tempTimeArray.map((item,index)=>{
                        item._id = index;
                        item._time = String(item.startTime).substr(0,String(item.startTime).lastIndexOf(':')) + " - " + String(item.endTime).substr(0,String(item.endTime).lastIndexOf(':'));
                    })
                    this.timeArray = tempTimeArray;
                    //  日历数据
                    this.calendarData = [];

                    //  假数据
                    // calendarDataArray.push({
                    //     dateTime: "20200102",
                    //     appointSet: "ca638829fcd14570bd05b0624b57c737",
                    //     limitNum: 7000,
                    //     restNum: 7000,
                    // })

                    calendarDataArray.map(item=>{
                        this.calendarData.push({
                            time: item.dateTime,
                            number: item.restNum,
                            restNum: item.restNum,
                            id: item.appointSet,
                        })
                    }) 

                    //  闭馆时间
                    this.closureArray = closeArray;

                    this.createAlendar();
                    //  选中最近的一个入馆时间
                    if(this.calendarData.length >= 1){
                        const obj = this.calendarData[0];
                        $(`li[data='${obj.time}']`).addClass('active-date')
                    }

                })   
                .catch(e=>{
                    //  出错情况
                    this.createAlendar();
                    const obj = this.calendarData[0];
                    $(`li[data='${obj.time}']`).addClass('active-date')
                    // console.log(e)
                })
            },
            nextStep(){
                if(this.getChooseYear == undefined || this.getChooseYear == ''){
                    this.$toast('暂无可选报名时间')
                    return;
                } 
                // else if(!this.check){
                //     this.$toast('请阅读并勾选预约须知');
                // }else{
                // }
                this.$router.push({name:'fillActivityInfo',query:{ activityId: this.activityId, applyActivityDate: this.getChooseYear }})
            },
            onChangeTimeActive(item){
                return ()=>{
                    const {
                        _id,
                        status = 0
                    } = item;
                    if(status === 0){
                        this.$toast('此入馆时间不可选')
                        return
                    }
                    this.timeActive = _id;
                }
            },
            checkChange(){
                this.check = !this.check;
            },
            onChangeTab(v){
                return ()=>{
                    this.tickerModel = v ;
                }
            },
            createAlendar(){
                Calendar($, window, document);
                    this.calendarObj = $('#calendar').calendar({
                    ifSwitch: true, // 是否切换月份
                    hoverDate: true, // hover是否显示当天信息
                    backToday: true, // 是否返回当天
                    calendarData: this.calendarData,
                    closureData: this.closureArray,
                    callBack:()=>{
                        this.currendDate = this.calendarObj.chooseDate;
                        // this.timeActive = 0;
                        // if(this.getTimeArray){
                        //     this.timeActive = this.getTimeArray[0].id;
                        // }
                    }
                });
                this.currendDate = this.calendarObj.chooseDate;
            }
        },

        computed: {
            getTimeArray(){

                var array = this.calendarData,
                    timeArray = this.timeArray,
                    tempObj = null,
                    timeObj = null;
                
                //  获取到对应天数对象 必然等于 1
                array = array.filter(item=>{
                    if(item.time === this.currendDate){
                        return item
                    }
                })

                //  过滤时段数组
                if( array.length === 1 ){
                    timeObj = array[0];
                    timeArray = timeArray.filter(item=>{
                        if( timeObj.id === item.appointSet ){
                            return item;
                        }
                    })
                }

                //  没有匹配到时段 增设默认时段
                if( timeArray.length === 0 && array.length === 1 ) {
                    timeArray = [
                        {
                            appointSet: '',
                            limitNum: timeObj && timeObj.limitNum || '',
                            restNum: timeObj && timeObj.restNum || '',
                            endTime: this.defaultStartTime,
                            startTime: this.defaultEndTime,
                            status: 1,
                            _id: 0,
                            _time: `${this.defaultStartTime} - ${this.defaultEndTime}`,
                            // endTime: "17:00:00",
                            // startTime: "08:00:00",
                            // _time: "08:00 - 17:00",
                        }
                    ]
                }

                // console.log(timeArray)
                // if(timeArray.length>1){
                //     // timeArray[0].status = 0;
                //     timeArray.push(timeArray[0])
                //     timeArray.push(timeArray[0])
                //     timeArray.push(timeArray[0])
                //     timeArray.push(timeArray[0])
                //     timeArray.push(timeArray[0])
                // }

                //  设置第一个默认选中
                if(timeArray.length >= 1) {
                    // timeArray[0].status = 0
                    // timeArray[3].status = 0
                    // this.timeActive = timeArray[0]._id;
                    // //  2020年04月03日1 杨秀麦让后台加入的时段控制
                    for (let index = 0, len = timeArray.length; index < len; index++) {
                        const element = timeArray[index];
                        if(element.status === 1){
                            this.timeActive = element._id;
                            break
                        }
                    }
                }

                return timeArray;
            },
            getChooseTime(){
                var array = this.getTimeArray || [];
                // const array = this.timeArray.filter(item => {
                    array = array.filter(item => {
                    if(item._id === this.timeActive){
                        return item._time
                    }
                })
                if(array[0]?.status === 1 && array.length === 1){
                    return array[0]._time 
                }else{
                    return '';
                }
            },
            getTimeSlotNumber(){
                var array = this.getTimeArray || [];
                // var array = this.timeArray.filter(item => {
                    array = array.filter(item => {
                    if(item._id === this.timeActive){
                        return item.restNum
                    }
                })
                if(array.length === 1){
                    return array[0].restNum
                }
            },
            getChooseYear(){
                var year = this.currendDate;
                var yearStr = '';
                if(year) {
                    this.check = true;
                    yearStr = year.substr(0, 4) + '-' + year.substr(4, 2) + '-' + year.substring(6);
                }
                return yearStr;
            },
        },


    }
</script>

<style lang="less" scoped>
    @import "./style/calendar.css";
    @import "./style/home-public-style.less";

    .contaier{
        background:rgba(241,242,252,1) !important;
        padding-bottom: 50px;
        .calendar-box{
            padding: 7px 11px 0;
        }
        .felx-box{
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .white-box{
            background-color: white;
        }
        .padding-box-h{
            box-sizing: border-box;
            @size:22px;
            padding-left: @size;
            padding-right: @size;
        }
        .padding-box-v{
            padding-top: 14px;
            padding-bottom: 14px;
        }
        .unified-box-bottom{
            margin-bottom: 12px;
        }
        .calendar{
            padding: 0;
            padding-bottom: 1px;
            background-color: white;
            box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
        }
        .tips-txt{
            white-space: nowrap;
            color: #444444;
        }
        .header{
            box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
            background-color: white;
            @headerHeight:56px;
            height: @headerHeight;
            display: flex;
            align-items: center;
            .header-item{
                transition: all .3s ease;
                @itemHeight:30px;
                height: @itemHeight;
                line-height: @itemHeight;
                font-size: 15px;
                font-weight: 500;
                text-align: center;
                box-sizing: border-box;
                width: 50%;
                display: inline-block;
                &:nth-child(2){
                    border-left: .1px solid #ebedf0;
                }
                span{
                    padding: 10px 20px;
                }
            }
        }
        .header-line{
            background-color: white;
            margin-bottom: 5px;
            .line{
                transition: all .3s ease;
                width: 50%;
                text-align: center;
                font-size: 0;
                .inner-line{
                    border-radius: 100px;
                    overflow: hidden;
                    display: inline-block;
                    width: 65px;
                    height: 4px;
                }
            }
            .line-right{
                margin-left: 50%;
            }

        }
        .environment-box{
            font-size: 14px;
            // height: 56px;
            padding-top: 14px;
            padding-bottom: 14px;
            .felx-box();
            .white-box();
            .padding-box-h();
            justify-content: flex-start;
            .environment-left{
                width: 90px;
                font-weight: 500;
                color: #666666;
                .felx-box();
                .icon-size{
                    margin-right: 5px;
                    &::before{
                        font-size: 23px;
                    }
                }
            }
            .environment-right{
                font-weight: 500;
                color: #b6b4bc;
                padding-left: 20px;
            }
        }
        .admission-time{
            font-size: 14px;
            box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
            // padding-top: 14px;
            // padding-bottom: 14px;
            padding: 12px 11px;
            overflow: hidden;
            margin-left: 11px;
            margin-right: 11px;
            border-radius: 5px;
            justify-content: flex-start;
            .white-box();
            .unified-box-bottom();
            // .padding-box-h();
            .admission-left{
                box-sizing: border-box;
                padding: 5px 0 0;
                vertical-align: top;
                // width: 90px;
                font-weight: 500;
                margin-right: 10px;
                color: #666666;
                float: left;            
                .felx-box();
                .icon-size{
                    color: #FFB200;
                    margin-right: 5px;
                    &::before{
                        font-size: 23px;
                    }
                }
            }
            .admission-right{
                box-sizing: border-box;
                // margin-bottom: -10px;
                float: left;                        
                vertical-align: top;
                color: #b6b4bc;
                // padding-left: 20px;
                width: ~"calc( 100% - 100px )";
                .right-item{
                    box-sizing: border-box;
                    color: #4282ff;
                    border: 1px solid #4282ff;
                    white-space: nowrap;
                    display: inline-block;
                    padding: 10px;
                    border-radius: 4px;
                    border-width: 1px;
                    text-align: center;
                    margin-right: 10px;
                    margin-bottom: 10px;
                    box-sizing: border-box;
                    width: ~'calc(50% - 5px)';
                    &:nth-child(2n+2){
                        margin-right: 0;
                    }
                }
                .prohibit-item{
                    color: #ffffff;
                }
                .right-item-active{
                    color: #ffffff;
                }
            }
        }
        .tips-number{
            padding-top: 0;
            .felx-box();
            justify-content: flex-start;
            .admission-right{
                float: none;
                margin: 0;
                width: auto;
                padding-right: 15px;
            }
        }
        .tips-box-header{
            color: #8A8A8A;
            font-size: 14px;
            font-weight: 500;
            .padding-box-h();
            .padding-box-v();
        }
        .tips-box-body{
            padding-left: 11px;
            padding-right: 11px;
            .render-box{
                background-size: 118px 142px;
                background-repeat: no-repeat;
                background-position: right bottom;
                background-image: url('../../lib/image/home/567.png');
                box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
                border-radius: 5px;
                overflow: hidden;
                color: #7D7D7D;
                font-size: 13px;
                font-weight: 500;
                // .padding-box-v();
                // .padding-box-h();
                padding: 12px 11px;
                .white-box();
                .render-tite{
                    padding-left: 0;
                    justify-content: flex-start;
                    font-weight: 500;
                    padding-bottom: 14px;
                    margin-bottom: 0;
                    font-size: 14px;
                    color: #444444;
                    .icon-size{
                        color: #F9972D;
                        margin-right: 5px;
                        &::before{
                            font-size: 22px;
                            display: inline-block;
                            vertical-align: top;
                            transform: translateY(-2px);
                        }
                    }
                }
                li{
                    font-size:15px;
                    font-weight:400;
                    margin-bottom: 7px;
                    padding-left: 5px;
                    &:last-child{
                        margin-bottom: 0;
                    }
                }
            }
        }
        .check-box{
            font-size: 14px;
            color: #7D7D7D;
            .padding-box-v();
            .padding-box-h();
            .txt{
                font-weight: 500;
                margin-left: 10px;
            }
            .iconhebei{
                &::before{
                    font-size: 15px;
                }
            }
        }
        .next-box{
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            height: 50px;
            .felx-box();
            // .padding-box-v();
            .padding-box-h();
            .white-box();
            .next-box-left{
                font-size: 12px;
                color: #7D7D7D;
                white-space: nowrap;
                .item{
                    margin-right: 10px;
                    font-weight: 500;
                    &:last-child{
                        margin: 0;
                    }
                }
            }
            .next-box-right{
                // width: 80px;
                position: absolute;
                right: 0;
                top: 0;
                height: 100%;
                width: 110px;
                .felx-box();
                align-content: center;
                justify-content: center;
                color: white;
            }
            .gray-btn{
                filter: grayscale(1);
            }
        }
    }
</style>
